"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpCache = void 0;
class HttpCache {
    serializeCacheKey(payload) {
        try {
            return JSON.stringify(payload);
        }
        catch (_e) {
            return payload.url + String(Math.random());
        }
    }
}
exports.HttpCache = HttpCache;
